import { useEffect, useState } from "react";
import Header from "./Header";
import axios from "axios";
import MarketplaceCampaignPreview from "./MarketplaceCampaignPreview";
import { useNavigate } from "react-router-dom";
import MarketplaceDevicePreview from "./MarketplaceDevicePreview";

function Marketplace() {
    const navigate = useNavigate();
    const [campaigns, setCampaigns] = useState([]);
    const [freeCampaigns, setFreeCampaigns] = useState([]);
    const [devices, setDevices] = useState([]);

    function loadCampaigns() {
        axios.get(
            process.env.REACT_APP_API_HOST + '/campaign/public/',
            {
                headers: {
                    'Authorization': localStorage.getItem('token'),
                }
            }
        ).then(
            (response) => {
                setCampaigns(response.data);
            }
        ).catch(
            (error) => {
                localStorage.removeItem('token');
                localStorage.removeItem('user_id');
                navigate('/');
            }
        )
    }

    function loadCampaignsFree() {
        axios.get(
            process.env.REACT_APP_API_HOST + '/campaign/public/free/',
            {
                headers: {
                    'Authorization': localStorage.getItem('token'),
                }
            }
        ).then(
            (response) => {
                setFreeCampaigns(response.data);
            }
        ).catch(
            (error) => {
                localStorage.removeItem('token');
                localStorage.removeItem('user_id');
                navigate('/');
            }
        )
    }

    function loadPublicDevices() {
        axios.get(
            process.env.REACT_APP_API_HOST + '/device/public/',
            {
                headers: {
                    'Authorization': localStorage.getItem('token'),
                }
            }
        ).then(
            (response) => {
                setDevices(response.data);
            }
        ).catch(
            (error) => {
                // localStorage.removeItem('token');
                // localStorage.removeItem('user_id');
                // navigate('/');
            }
        )
    }

    useEffect(
        () => {
            loadCampaigns();
            loadCampaignsFree();
            loadPublicDevices();
        },
        [],
    )

    const divCampaigns = campaigns.map(
        c => <MarketplaceCampaignPreview campaign={c} />
    )

    const divFreeCampaigns = freeCampaigns.map(
        c => <MarketplaceCampaignPreview campaign={c} />
    )

    const divDevices = devices.map(
        d => <MarketplaceDevicePreview device={d} />
    )

    return (
        <div align='center' style={{ marginTop: '6em' }}>
            <Header />
            <div className="standard-box3" style={{ marginTop: '2em', display: 'flex', alignItems: 'center' }}>
                <div>
                    <i
                        className="pi pi-heart"
                        style={{ fontSize: '1.8rem', marginRight: '0.5em' }}
                    />
                </div>
                <h3>
                    Campaigns for Good
                </h3>
            </div>
            <div
                className="standard-box3"
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                }}
            >
                {divFreeCampaigns}
            </div>
            <div className="standard-box3" style={{ marginTop: '2em', display: 'flex', alignItems: 'center' }}>
                <div>
                    <i
                        className="pi pi-briefcase"
                        style={{ fontSize: '1.8rem', marginRight: '0.5em' }}
                    />
                </div>
                <h3>
                    Find Ads to Monetize your Screens
                </h3>
            </div>
            <div
                className="standard-box3"
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                }}
            >
                {divCampaigns}
            </div>

            <div className="standard-box3" style={{ marginTop: '2em', display: 'flex', alignItems: 'center' }}>
                <div>
                    <i
                        className="pi pi-map-marker"
                        style={{ fontSize: '1.8rem', marginRight: '0.5em' }}
                    />
                </div>
                <h3>
                    Find Places for your Ads
                </h3>
            </div>
            <div
                className="standard-box3"
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                }}
            >
                {divDevices}
            </div>
        </div>
    );
}

export default Marketplace;